import { memo, useCallback } from 'react';
import type { Spell } from '../types';
import './SpellCard.css';

interface SpellCardProps {
  spell: Spell;
  isSelected: boolean;
  onToggle: (id: string) => void;
}

export const SpellCard = memo(function SpellCard({ spell, isSelected, onToggle }: SpellCardProps) {
  const handleToggle = useCallback(() => {
    onToggle(spell.id);
  }, [onToggle, spell.id]);

  const handleCheckboxClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <div
      className={`spell-card-mini ${isSelected ? 'selected' : ''}`}
      onClick={handleToggle}
    >
      <div className="spell-card-mini-header">
        <span className="spell-level-badge">{spell.level}</span>
        <h3>{spell.name}</h3>
      </div>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={handleToggle}
        onClick={handleCheckboxClick}
        className="spell-checkbox"
        aria-label={`Select ${spell.name} for print`}
      />
    </div>
  );
});
